import React, { useEffect, useState } from 'react';
import 'react-html5video/dist/styles.css';
import ControlRadio from 'lqa-ui/lib/Components/ControlRadio';
import QuestionResponse from './QuestionResponse';
import {
  Wrapper,
  CountDownTimer,
  QuestionTitle,
  AnswerChoices,
  Answer,
  ButtonContainer,
  ButtonBlock,
} from './Quizzes.styled';
import { Body4 } from './../../../app/common/typography';
import { ButtonLarge } from './../../../app/common/sharedComponents/buttons/ButtonLarge';

const Question = ({ data, nextQuestionHandler, setQuizScore }) => {
  const [answerSelected, setAnswerSelected] = useState<any>(null);
  const [answered, setAnswered] = useState(false);
  const [counter, setCounter] = useState(25);
  const [questionCounterActive, setQuestionCounterActive] = useState(true);
  const [inactivityCounter, setInactivityCounter] = useState(500);
  const [inactivityCounterActive, setInactivityCounterActive] = useState(false);
  const [startInactivity, setStartInactivity] = useState(false);

  const onChoicesChange = (event) => {
    const answerSelectedId = event.target.id;
    setAnswerSelected(
      data.answers.find(
        (answer) => String(answer.id) === String(answerSelectedId)
      )
    );
  };

  const onAnswerHandler = () => {
    setAnswered(true);
    setCounter(500);
    setInactivityCounter(30);
    setStartInactivity(false);
    setInactivityCounterActive(false);
    setQuestionCounterActive(false);
  };

  useEffect(() => {
    if (!questionCounterActive) {
      return;
    }
    const countTimeout = setTimeout(() => setCounter(counter - 1), 1000);
    const count = counter > 0 && countTimeout;
    if (!count) {
      setStartInactivity(true);
      setInactivityCounter(30);
      setInactivityCounterActive(true);
      setAnswered(true);
      setAnswerSelected(data.answers[0]);
      setQuestionCounterActive(false);
    }
    return () => clearTimeout(countTimeout);
  }, [counter]);

  return (
    <Wrapper>
      {answered ? (
        <QuestionResponse
          question={data}
          answerSelected={answerSelected}
          setQuizScore={setQuizScore}
          startInactivity={startInactivity}
          inactivityCounter={inactivityCounter}
          setInactivityCounter={setInactivityCounter}
          inactivityCounterActive={inactivityCounterActive}
          onContinueHandler={() => {
            setAnswered(false);
            setInactivityCounter(500);
            setCounter(25);
            nextQuestionHandler();
            setAnswerSelected(null);
            setInactivityCounterActive(false);
            setQuestionCounterActive(true);
          }}
        />
      ) : (
        <>
          <QuestionTitle>{data.label}</QuestionTitle>
          <CountDownTimer>Time remaining {counter}s</CountDownTimer>
          <AnswerChoices>
            {data.answers.map((answer) => (
              <Answer key={answer.id}>
                <ControlRadio
                  key={answer.id}
                  id={answer.id}
                  checked={
                    String(answer.id) ===
                    String(answerSelected && answerSelected.id)
                  }
                  onChange={onChoicesChange}
                />
                <Body4 color="darkBlue">{answer.label}</Body4>
              </Answer>
            ))}
          </AnswerChoices>
          <ButtonContainer>
            <ButtonBlock>
              <ButtonLarge
                disabled={!answerSelected}
                title="Answer"
                onClick={() => onAnswerHandler()}
              />
            </ButtonBlock>
          </ButtonContainer>
        </>
      )}
    </Wrapper>
  );
};

export default Question;
